

import { Component , OnInit } from '@angular/core';
import { NavController,  AlertController  } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service';
import { Http} from '@angular/http';
import { CommonService } from '../../services/common.service';
import 'rxjs/add/operator/do';
import { Events } from 'ionic-angular';

import {FormGroup,FormControl,Validators,FormBuilder } from "@angular/forms";
import { LoginComponent } from '../login/login';
declare var gtag;



//@IonicPage()


/*@IonicPage({
  name: "Register",
  segment: "app"
}
)*/

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage implements OnInit{
  createSuccess = false;
  isSecondStep=false;
  registerCredentials :any = { firstName : '', lastName : ''};
  autocompleteItems=[];
  allCategory : any;
  autocomplete={query:''};

  defaultSegment: string = "companyInfo";
  dateTime = {
    month: '1990-02-19',
    timeStarts: '07:43',
    timeEnds: '1990-02-20'
  }

  /*******Validation Start************/
  registerForm = new FormGroup({
    firstName: new FormControl(), 
    lastName: new FormControl(), 
    email: new FormControl(),
    categoryId: new FormControl(),
    companyAddress: new FormControl(),
    contactNumber : new FormControl(),
    companyName: new FormControl(),
    password: new FormControl(),
    confirmPassword: new FormControl() 
  });



  submitAttempt: boolean = false;
  label: any = {}; 
  emailRegx: any;
  passwordRegx: any;
  nameRegx: any;
  phoneNumberRegx: any;
  messageLabel: any;
  userdata: any;

  /*******Validation End************/



  constructor(private nav: NavController, private auth: AuthService, private alertCtrl: AlertController, private http:Http, public fb: FormBuilder , public commonService :CommonService , public events: Events ) { 


    // this.registerForm = fb.group({
    //   "password": this.password,
    //   "confirmPassword": this.confirmPassword,
    //   "email": ''
    // }, {validator: this.matchingPasswords('password', 'confirmPassword')});

    /*this.registerForm.get('password').updateValueAndValidity();
    this.registerForm.get('confirmPassword').updateValueAndValidity();

    this.registerForm.markAsPristine();*/
  }


  ionViewDidLoad() {


  }



  public getCategories(){

    this.commonService.getCategories().subscribe(success => {
      if (success) {

        this.allCategory=success.data;
        //this.showPopup("Success", "Account created.");
      } else {
        this.showPopup("Error", "Problem creating account.");
      }

    })
  }

  ngOnInit(){ 

     gtag('event', 'conversion_event_purchase', {});
    /* this.emailRegx = this.validator.emailRegx;
    this.passwordRegx = this.validator.passwordRegx;
    this.nameRegx = this.validator.nameRegx;
    this.phoneNumberRegx = this.validator.phoneNumberRegx; */
    var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;


    this.registerForm = this.fb.group({
      firstName: [this.registerCredentials.firstName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])],
      lastName: [this.registerCredentials.lastName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])],
      companyName: [this.registerCredentials.companyName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z1-9 ]{2,32}')])],
      email: [this.registerCredentials.email, Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      password: [this.registerCredentials.password, Validators.compose([Validators.required,  Validators.minLength(6)])],
      confirmPassword: [this.registerCredentials.confirmPassword, Validators.compose([Validators.required])],
      categoryId: [this.registerCredentials.categoryId, Validators.compose([Validators.required])],
      companyAddress: [this.registerCredentials.address, Validators.compose([Validators.required])],
      contactNumber: [this.registerCredentials.contactNumber, Validators.compose([Validators.required, Validators.minLength(5), Validators.minLength(10)])],      

    }, 

    {'validator': this.matchingPasswords('password', 'confirmPassword')});  

    this.getCategories();

  }


  public matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      let passwordInput = group.controls[passwordKey];
      let passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({notEquivalent: true})
      }
    }
  }

  public register(formValues) {
    if(!this.commonService.listenConnection()){
      return false;
    }

    if(!this.isSecondStep){
      this.isSecondStep=true;
      this.defaultSegment="adminInfo";
      return false;

    }


    if(this.registerCredentials.password!=this.registerCredentials.confirmPassword){
      this.showPopup("Fail", "Password did not match with confirm password.");
      return;
    }


   this.commonService.showLoading();


     //this.nav.push('RatingFactorPage');
     this.auth.register(formValues).subscribe(success => {


       this.commonService.dismisshowoading();
       if (success && success.status=="success") {
          //  this.createSuccess = true;

          this.showPopup("Success", "Account created.");
          //if logged-in user is not supper admin
          var  userrole=(!success.data.isSuperAdmin || success.data.isSuperAdmin=="0")?'admin':'super-admin';

          this.events.publish('user:logged-in', {role:userrole,fullName:success.data.fullName,subscribedPlan:success.data.company.subscribedPlan}, Date.now()); 
          this.commonService.setLoggedInUserData(success.data);

          //check if user buy the price plan before singup
          this.commonService.checkPricePlanAndUpdateDb();

          let defultRatingFactors=success.data.defultRatingFactors;
          this.nav.setRoot('RatingFactorPage', {defultRatingFactors:defultRatingFactors});
          
        } else {
          success=JSON.parse(success);
          this.showPopup("Fail", success.message);
        }
      });/*,
      error => {
        this.commonService.dismisshowoading();
        console.log("ssssssssssss error",error);
        this.showPopup("Error server", error);
      });*/
   }

   chooseItem(item: any) {
     this.autocompleteItems=[];
     this.autocomplete.query=item.description
   }
   public loginNow(){
     this.nav.setRoot(LoginComponent);
   }


   public getGooglePlaces(event){


     let me =this;
     this.http.get('http://35.165.185.224:3000/api/getPlaces?search='+this.autocomplete.query)
     .map(response => response.json())
     .subscribe(data => {


       console.log(data);

       me.autocompleteItems=data.predictions;

     // observer.next(data);
      //observer.complete();
    }, error => {
        console.log(error);// Error getting the data
        //observer.next(false);
        //observer.complete();
      });;
      //$scope.filterTag=_.pluck(data,'description');
      //return $scope.filterTag;


    }




    showPopup(title, text) {
      let alert = this.alertCtrl.create({
        title: title,
        subTitle: text,
        buttons: [
        {
          text: 'OK',
          handler: data => {
            if (this.createSuccess) {
              this.nav.popToRoot();
            }
          }
        }
        ]
      });
      alert.present();
    }
  }


// WEBPACK FOOTER //
// ./src/pages/login/register.ts